webpackJsonp([6],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	/* global require, ga, _hmt */
	__webpack_require__(4);
	
	__webpack_require__(9);
	
	__webpack_require__(7);
	
	__webpack_require__(10);
	
	__webpack_require__(11);
	
	__webpack_require__(12);
	
	__webpack_require__(6);
	
	__webpack_require__(5);
	
	__webpack_require__(13);
	
	__webpack_require__(25);
	
	__webpack_require__(3);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	__webpack_require__(2);
	
	__webpack_require__(8);
	
	$(function() {
	  var $area, $form, $mobile, $truename;
	  if ($('#baojia').length > 0) {
	    $form = $('#baojia');
	    $area = $form.find('[name="area"]');
	    $truename = $form.find('[name="truename"]');
	    $mobile = $form.find('[name="mobile"]');
	    $form.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: false,
	          confirmButtonColor: '#08b3ae'
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            var ref, ref1;
	            if (((ref = res.msg) != null ? (ref1 = ref[0]) != null ? ref1.type : void 0 : void 0) === 'success') {
	              swal({
	                customClass: 'alert-success',
	                title: '您已经报价成功',
	                text: '稍后家装顾问会回电给您。请注意接听来电！',
	                confirmButtonText: '返  回',
	                confirmButtonColor: '#08b3ae',
	                allowOutsideClick: true,
	                html: true,
	                timer: 1000000
	              });
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    $mobile.rules('add', {
	      required: true,
	      mobileNum: true,
	      messages: {
	        required: '请输入11位手机号码',
	        mobileNum: '请输入正确的手机号'
	      }
	    });
	    $truename.rules('add', {
	      required: true,
	      messages: {
	        required: '输入您的姓名'
	      }
	    });
	    return $area.rules('add', {
	      required: true,
	      messages: {
	        required: '输入翻新面积'
	      }
	    });
	  }
	});


/***/ },

/***/ 25:
4

});


/** WEBPACK FOOTER **
 ** dmfx.95970418f4f1538a045f.js
 **/